import { Box, Card, Text } from '@mantine/core';

const GoogleAudienceInfo = ({ info }) => {
  return (
    <Card withBorder>
      <Card.Section inheritPadding py="sm">
        <Text fw={500} ta="center" mb="sm">
          Audience Details
        </Text>
        <Box ta="center">
          <small>
            <div>
              <strong>Audience ID:</strong> {info.id}
            </div>
            <Box component="hr" my="sm" />
            <div style={{ marginTop: 'var(--mantine-spacing-xs)' }}>
              <strong>Total Users:</strong> {info.totalUsers?.toLocaleString() || 0}
            </div>
            <div style={{ marginTop: 'var(--mantine-spacing-xs)' }}>
              <strong>Active Users:</strong> {info.activeUsers?.toLocaleString() || 0}
            </div>
            <Box component="hr" my="sm" />
            <div style={{ marginTop: 'var(--mantine-spacing-xs)' }}>
              <strong>Active users (1 Day):</strong> {info.active1DayUsers?.toLocaleString() || 0}
            </div>
            <div style={{ marginTop: 'var(--mantine-spacing-xs)' }}>
              <strong>Active users (7 Days):</strong> {info.active7DayUsers?.toLocaleString() || 0}
            </div>
            <Box component="hr" my="sm" />

            <div style={{ marginTop: 'var(--mantine-spacing-sm)' }}>
              <strong>Status: </strong>
              {info.operationStatus?.isReady ? 'Ready' : 'Not Ready'}
            </div>
            <div style={{ marginTop: 'var(--mantine-spacing-xs)' }}>
              {info.operationStatus?.description || 'No data available'} (Code:{info.operationStatus?.code || '200'})
            </div>
          </small>
        </Box>
      </Card.Section>
    </Card>
  );
};

export default GoogleAudienceInfo;
